import $ from 'jquery';

$('body').on('DOMSubtreeModified', () => {
    if ($('.clickdform select').length > 0) {
        $('.clickdform select').parent().addClass('dropdown-wrapper');
    }
});

const initClickDimension = () => {
    const $form = $('.click-dimension-form');

    if ($form.length === 0) return;

    $form.on('click', '#btnSubmit', function () {
        const $errors = $(this).closest('form').find('.requiredInfo > div');

        if ($errors.length > 0) {
            $('html, body').animate(
                { scrollTop: $errors.first().closest('.responsiveRow').offset().top },
                300,
                () => {
                    $errors.first().closest('.responsiveRow').find('input, textarea, select').first()
                        .focus();
                }
            );
        }
    });
};

const createSurveyRadioLabel = () => {
    const $radios = $('.click-dimension-form td input[type="radio"]');

    if ($radios.length === 0) return;

    $radios.each(function () {
        const $el = $(this);
        if ($el.closest('tr').find(`label#${$el.attr('id')}`).length === 0) {
            $el.after('<span class="box"></span>');
            $el.closest('tr').find('td').addClass('valignTop').wrapInner(`<label for="${$el.attr('id')}" class="styled-radio"></label>`);
        }
    });
};

const initClickDimensionLabel = () => {
    const cdForm = $('.click-dimension-form');
    let timeout = setTimeout(() => {}, 0);

    if (cdForm.length === 0) return;

    const createLabel = () => {
        const $checkboxs = $('.click-dimension-form input[type="checkbox"]');

        if ($checkboxs.length === 0) return;

        $checkboxs.each(function () {
            const $el = $(this);
            if ($el.closest('.responsiveRow').find(`label#${$el.attr('id')}`).length === 0) {
                $el.after('<span class="box"></span>');
                $el.parent().wrap(`<label for="${$el.attr('id')}" class="styled-checkbox"></label>`);
            }
        });
    };

    const clearTimer = timer => clearTimeout(timer);

    const initTimer = () => {
        timeout = setTimeout(() => {
            if ($('.click-dimension-form form').length > 0) {
                createLabel();
                createSurveyRadioLabel();
                clearTimer(timeout);
                return;
            }

            initTimer();
        }, 100);
    };

    initTimer();
};

$(() => {
    initClickDimension();
    initClickDimensionLabel();
});



// WEBPACK FOOTER //
// ./src/js/click-dimension-form-overrides.js